/** Browser-safe technical timings. Never extend product events or include request/user payloads. */
import * as z from 'zod'

export const startupRoutes = [
  '/api/me',
  '/api/testfeed-connection-status',
  '/api/store-sync/status',
  '/api/testfeed-usage',
  '/api/testfeed-usage/plan-selection',
  '/api/testfeed-entitlements',
] as const

// Relative to this iframe's performance.timeOrigin, not the Shopify host navigation.
const milliseconds = z.number().finite().min(0).max(3_600_000)
export const startupContentSchema = z.enum(['connected-shell', 'settings', 'launch-admission', 'connection-recovery'])
export const startupRequestSchema = z.strictObject({
  route: z.enum(startupRoutes),
  startedAt: milliseconds,
  dispatchedAt: milliseconds.optional(),
  respondedAt: milliseconds.optional(),
  status: z.number().int().min(100).max(599).optional(),
  correlationId: z
    .string()
    .regex(/^[a-zA-Z0-9_-]{1,64}$/)
    .optional(),
  outcome: z.enum(['pending', 'response', 'aborted', 'rejected']),
})
export const startupTimingSchema = z.strictObject({
  version: z.literal(1),
  navigationId: z.uuid(),
  navigationStartedAt: z.literal(0),
  clientBuild: z
    .string()
    .regex(/^[a-f0-9]{40}$/)
    .optional(),
  jsStartedAt: milliseconds,
  bridgeWaitStartedAt: milliseconds.optional(),
  bridgeReadyAt: milliseconds.optional(),
  bootstrapParseStartedAt: milliseconds.optional(),
  bootstrapParsedAt: milliseconds.optional(),
  contentCommittedAt: milliseconds,
  content: startupContentSchema,
  reportedAt: milliseconds,
  completion: z.enum(['settled', 'deadline']),
  droppedRequests: z.number().int().min(0).max(10_000),
  requests: z.array(startupRequestSchema).max(12),
})
export const startupTimingBodySchema = z.strictObject({
  kind: z.literal('startup-timing'),
  report: startupTimingSchema,
})
export type StartupTiming = z.infer<typeof startupTimingSchema>
export type StartupRequestTiming = z.infer<typeof startupRequestSchema>
